module.exports = __webpack_public_path__ + "img/icon_footer_hkfs_selected.ddc1544a.png";